export const SET_LANGUAGE = 'SET_LANGUAGE';

export const CHANGE_LANGUAGE_REQUEST = 'CHANGE_LANGUAGE_REQUEST';
export const CHANGE_LANGUAGE_SUCCESS = 'CHANGE_LANGUAGE_SUCCESS';
export const CHANGE_LANGUAGE_FAILURE = 'CHANGE_LANGUAGE_ERROR';

export const setLanguage = language => ({
  type: SET_LANGUAGE,
  payload: { language }
});

export const changeLanguageRequest = language => ({
  type: CHANGE_LANGUAGE_REQUEST,
  payload: { language }
});

export const changeLanguageSuccess = language => ({
  type: CHANGE_LANGUAGE_SUCCESS,
  payload: { language }
});

export const changeLanguageFailure = err => ({
  type: CHANGE_LANGUAGE_FAILURE,
  payload: err,
  error: true
});



// WEBPACK FOOTER //
// ./src/store/language/actions.js